"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasNomineeShareholders = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.HasNomineeShareholders = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_business_information.has_nominee_shareholders.label',
    fallbackLabel: 'Does your company have nominee shareholders, or are there any nominee shareholders in the ownership and control structure?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
